import _ from 'lodash'
import {
    getOrderInfo,
    getOrderByHxId,
    getSaleOrderByHxId,
    getSalesOrderInfo
} from '@/api/custom.js'
const Orders = {
    state: {
        // friendList: useLocalStorage('friendList', {}),
        friendList: {},
        // groupList: useLocalStorage('groupList', {}),
        groupList: {},
        // sortedFriendList: useLocalStorage('sortedFriendList', {}),
        sortedFriendList: {},
        friendBlackList: [],

        orderInfo: {},
        saleOrderInfo: {},
        SalesInfo: {}
    },
    mutations: {
        SETSales_ORDER_INFO: (state, payload) => {
            state.SalesInfo = payload
        },
        SET_ORDER_INFO: (state, payload) => {
            state.orderInfo = payload
        },
        SET_SALE_ORDER_INFO: (state, payload) => {
            state.saleOrderInfo = payload
        }
    },
    actions: {
        // 单聊获取销售订单信息
        getSaleOrderInfo: async ({ commit }, hxId) => {
            try {
                const { data } = await getSaleOrderByHxId(hxId)
                if (data) {
                    if (data.img) {
                        let imgs = JSON.parse(data.img)
                        console.log('%c Line:31 🍇 imgs', 'color:#6ec1c2', imgs)
                        if (imgs && imgs.length) {
                            data.titleImg = imgs[0].url
                        }
                    }
                    commit('SET_SALE_ORDER_INFO', data)
                } else {
                    commit('SET_SALE_ORDER_INFO', {})
                }
            } catch (error) {
                console.log('%c Line:30 🍎 error', 'color:#6ec1c2', error)
                commit('SET_ORDER_INFO', {})
            }
        },
        // 获取订单信息
        getOrderInfo: async ({ commit }, groupId) => {
            try {
                const { data } = await getOrderInfo(groupId)
                if (data) {
                    if (data.img) {
                        let imgs = JSON.parse(data.img)
                        console.log('%c Line:31 🍇 imgs', 'color:#6ec1c2', imgs)
                        if (imgs && imgs.length) {
                            data.titleImg = imgs[0].url
                        }
                    }
                    commit('SET_ORDER_INFO', data)
                } else {
                    commit('SET_ORDER_INFO', {})
                }
            } catch (error) {
                console.log('%c Line:30 🍎 error', 'color:#6ec1c2', error)
                commit('SET_ORDER_INFO', {})
            }
        },
        // 获取销售订单信息
        getSalesInfoOrderInfo: async ({ commit }, groupId) => {
            try {
                const { data } = await getSalesOrderInfo(groupId)
                if (data) {
                    if (data.img) {
                        let imgs = JSON.parse(data.img)
                        console.log('%c Line:31 🍇 imgs', 'color:#6ec1c2', imgs)
                        if (imgs && imgs.length) {
                            data.titleImg = imgs[0].url
                        }
                    }
                    commit('SETSales_ORDER_INFO', data)
                } else {
                    commit('SETSales_ORDER_INFO', {})
                }
            } catch (error) {
                console.log('%c Line:30 🍎 error', 'color:#6ec1c2', error)
                commit('SETSales_ORDER_INFO', {})
            }
        },
        // 单聊获取订单信息
        getOrderInfoByPerson: async ({ commit }, userId) => {
            console.log(
                '%c Line:24 单聊获取订单信息 userId',
                'color:#465975',
                userId
            )
            try {
                const { data } = await getOrderByHxId(userId)
                console.log(
                    '%c Line:27 🧀拿到订单数据 data',
                    'color:#e41a6a',
                    data
                )
                if (data) {
                    if (data.img) {
                        let imgs = JSON.parse(data.img)
                        console.log('%c Line:31 🍇 imgs', 'color:#6ec1c2', imgs)
                        if (imgs && imgs.length) {
                            data.titleImg = imgs[0].url
                        }
                    }
                    commit('SET_ORDER_INFO', data)
                } else {
                    commit('SET_ORDER_INFO', {})
                }
            } catch (error) {
                console.log('%c Line:30 🍎 error', 'color:#6ec1c2', error)
                commit('SET_ORDER_INFO', {})
            }
        }
    }
}

export default Orders
